'use client';

import { useEffect } from 'react';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

export default function CategoryTracker({ categorySlug, categoryName, vendorCount }) {
  useEffect(() => {
    trackEvent(EVENTS.CATEGORY_PAGE_VIEWED, {
      category_slug: categorySlug,
      category_name: categoryName,
      vendor_count: vendorCount
    });
    // Una vista por página montada: si las props cambian (un objeto nuevo en un refresh del RSC), no
    // es otra vista. Cambiar de página remonta el componente.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
